import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { Cmg1003LookupsModel } from '../../cmg-1003/models';

import { Cmg1003LookupsStore } from './lookups.store';
import { SecurityProfileRole } from '../security-profile';

@Injectable({ providedIn: 'root' })
export class Cmg1003LookupsQuery extends Query<Cmg1003LookupsModel> {
  protected store: Cmg1003LookupsStore;

  constructor() {
    const store = inject(Cmg1003LookupsStore);

    super(store);

    this.store = store;
  }

  /**
   * Selects a security profile role name by its ID.
   * @param profileId The ID of the security profile.
   * @returns The name (value) of the role, or undefined if not found.
   */
  getSecurityProfileNameById(profileId: number | string): SecurityProfileRole | undefined {
    const roles = this.getValue()?.securityProfileRoles;
    if (!roles) {
      return undefined;
    }

    const foundRole = roles.find((role) => Number(role.id) === Number(profileId));

    return foundRole?.value as SecurityProfileRole;
  }
}
